import {Pipe, PipeTransform} from '@angular/core';

export interface InvoiceFilterSortOptions {
  sort: string;
  view: 'statement' | 'invoices' | 'orders';
}

@Pipe({name: 'invoiceFilterSort'})
export class InvoiceFilterSortPipe implements PipeTransform {

  transform(invoices: Invoice[], options: InvoiceFilterSortOptions): Invoice[] {
    if (invoices) {
      switch (options.view) {

        case 'statement':
          return invoices
            .filter(i => i.balance > 1.0 || i.balance < -1.0)
            .sort(buildInvoiceComparator(options.sort));

        case 'invoices':
          return invoices
            .sort(buildInvoiceComparator(options.sort));

        default: // 'orders'
          return [];
      }
    }

    return [];
  }

}

function buildInvoiceComparator(sort: string): (i1: Invoice, i2: Invoice) => number {
  if (sort === 'date-desc') {
    return (i1, i2) => (i1.invoiceDate > i2.invoiceDate) ? -1 : 1;
  } else {
    return (i1, i2) => (i1.invoiceDate > i2.invoiceDate) ? 1 : -1;
  }
}

